/**
 * Centralized environment configuration
 * Single source of truth for all environment variables
 */

interface Config {
  auth: {
    clientId: string;
    issuer: string;
  };
  api: {
    baseUrl: string;
  };
  app: {
    version: string;
    build: string;
    deployment: string;
    baseUrl: string;
  };
  monitoring: {
    instana?: string;
  };
  iot: {
    endpoint?: string;
    region: string;
  };
}

export const config: Config = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID!,
    issuer: import.meta.env.VITE_ISSUER!,
  },
  api: {
    baseUrl: import.meta.env.VITE_BE_URL!,
  },
  app: {
    version: import.meta.env.VITE_VERSION || 'unknown',
    build: import.meta.env.VITE_BUILD || 'unknown',
    deployment: import.meta.env.VITE_DEPLOYMENT || 'local',
    baseUrl: import.meta.env.VITE_BASE_URL || window.location.origin,
  },
  monitoring: {
    instana: import.meta.env.VITE_INSTANA,
  },
  iot: {
    endpoint: import.meta.env.VITE_IOT_ENDPOINT,
    region: import.meta.env.VITE_IOT_REGION || 'us-east-2',
  },
} as const;

// Runtime validation for required variables
const requiredEnvVars = ['VITE_CLIENT_ID', 'VITE_ISSUER', 'VITE_BE_URL'] as const;

const missingVars = requiredEnvVars.filter((varName) => !import.meta.env[varName]);

if (missingVars.length > 0) {
  console.error(`Missing required environment variables: ${missingVars.join(', ')}`);
}
